import { emptyMarket } from "../../constants";
import { fillEmptyMarketSelections } from "../";
export const prepareEmptyMarket = (eventId, template, index) => {
    let emptyLocalMarket = Object.assign({}, emptyMarket);
    emptyLocalMarket.id = `${eventId}-empty-${index}`;
    emptyLocalMarket.selections = fillEmptyMarketSelections(template);
    emptyLocalMarket.template = template;
    return emptyLocalMarket;
};
//# sourceMappingURL=prepareEmptyMarket.js.map